/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SequenceAction = {
    CreateParkingProcess: 'CreateParkingProcess',
    EndParkingProcess: 'EndParkingProcess',
    TransitionZones: 'TransitionZones',
    LogOnly: 'LogOnly'
} as const;
export type SequenceAction = typeof SequenceAction[keyof typeof SequenceAction];

